<footer class="footer">
    <div class="content has-text-centered">
        <p>
            The source code is licensed
            <a href="http://opensource.org/licenses/mit-license.php">MIT</a>
        </p>
        <p>
            ~ Made with ❤️ and ☕️ by
            <a href="https://amhopkins.com">Adam Hopkins</a> ~
        </p>
    </div>
</footer>

<style>
    a {
        color: #ff0d68 !important;
    }
</style>
